export default {
  list: [
    {
      title: 'کارت به کارت',
      value: 'CARD'
    },
    {
      title: 'نقدی',
      value: 'CASH'
    },
    {
      title: 'حواله',
      value: 'CASH_TRANSFER'
    },
    {
      title: 'چک',
      value: 'CHECK'
    }
  ],
  values: {
    CARD: 'CARD',
    CASH: 'CASH',
    CASH_TRANSFER: 'CASH_TRANSFER',
    CHECK: 'CHECK'
  }
};
